import moment from 'moment';
import { store } from '../../store/store';

export function handleMonthPickerYearNavButtons() {
  function disableNextYearButton() {
    const todayMoment = moment();
    const nextYearButton = document.querySelector('.month-picker__year button:nth-of-type(2)');
    if (parseInt(document.querySelector('.month-picker__year p').innerText) >= todayMoment.year()) {
      nextYearButton.setAttribute('disabled', true);
      nextYearButton.classList.add('disable-year-in-picker');
    } else {
      nextYearButton.removeAttribute('disabled');
      nextYearButton.classList.remove('disable-year-in-picker');
    }

    const monthPickerInput = document.querySelector('.month-picker-input');
    let monthPickerInputValue = moment(monthPickerInput.value, 'MMMM, YYYY');
    let lastYearSameMonth = moment(monthPickerInput.value, 'MMMM, YYYY').subtract(1, 'years');

    if (monthPickerInputValue.isValid()) {
      if (monthPickerInputValue.isAfter(todayMoment, 'month')) {
        monthPickerInput.value = lastYearSameMonth.format('MMMM, YYYY');
      }
    }
  }

  disableNextYearButton();

  const yearNavButtons = document.querySelectorAll('.month-picker__year button:nth-of-type(1),.month-picker__year button:nth-of-type(2)');

  yearNavButtons.forEach(element => {
    element.addEventListener('click', disableNextYearButton);
  });
}

export function formatRepTime(minutes) {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  const sixthminute = Math.floor(remainingMinutes / 6);
  return `${hours}.${sixthminute}`;
}

export function calcRepTime(input) {
  let [hours, minutesFraction] = input.toString().split('.');
  hours = hours || 0;

  const totalMinutes = (parseInt(hours) * 60) + ((parseInt(minutesFraction) * 6) || 0);

  return totalMinutes;
}


export function formatRepDate(date) {
  return moment(date).format('MMM D');
}

export function checkIsMentor() {
  let roles = store.state.roles;

  if (roles.indexOf('ROLE_MENTOR') > -1 && roles.indexOf('ROLE_ADMIN') == -1) {
    return true;
  } else {
    return false;
  }
}
export function checkIsManager() {
  let roles = store.state.roles;
  let switchFlag = store.state.switch_flag;

  if (roles.indexOf('ROLE_ADMIN') > -1 || switchFlag == 'Manager' || switchFlag == 'Primary Admin') {
    return true;
  } else {
    return false;
  }
}
export function checkIsMentee() {
  let roles = store.state.roles;

  if (roles.indexOf('ROLE_MENTEE') > -1 || roles.indexOf('ROLE_APPRENTICE') > -1) {
    return true;
  } else {
    return false;
  }
}

export function timeOnTaskInput(ev) {
  let value = ev.target.value;
  let valueRevised = parseFloat(value).toFixed(2);
  let valueRevisedParts = valueRevised.toString().split('.');
  let minutes = valueRevisedParts[1] || undefined;
  let newValue = '';


  return newValue;
}

export function customSleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}



// WEBPACK FOOTER //
// ./src/components/shared/utils.js